module.exports = __webpack_public_path__ + "static/media/cyberalpaca-logo-horizontal.97183049.svg";